import React, { useContext, useState, useEffect } from "react";
import { get, isEmpty } from "lodash";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import {
  faPencilAlt,
  faTimes,
  faTrashAlt,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Formik, Field } from "formik";
import {
  ManagePlanLayout,
  FieldInput,
  FieldInputSSN,
  DeleteWarning,
  LoaderWrapper,
} from "../../../components";
import * as Yup from "yup";
import {
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getFormattedSsn,
  getFormattedPhone,
  FORM_PLACEHOLDERS,
  getPathWithParam,
  getAdvancedPathWithParam,
  required,
} from "../../../utils";
import {
  createPlanStore,
  setManagePlanToastInfo,
  setManagePlanFlow,
  setManagePageLevelData,
  savePlanDetailsAction,
  setchangeReviewFlag,
} from "../../../contexts";
import { deleteSponsor, getSponsor, saveSponsor } from "../../../services";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
const characters = (value) => /^[a-zA-Z]+$/.test(value);
const digits = (value) => /^\d+$/.test(value);

const initialValues = {
  id: 0,
  middleName: null,
  workPhoneNumber: null,
  website: null,
  firstName: "",
};

let x = Math.pow(10, 3);

const take3Digits = (val) => {
  return Math.Truncate(val / Math.Pow(10, val.length - 3));
};
const AddSponsorContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const [newFlow] = useState("");
  const { planId, flow, sponsorId } = useRouterParams();
  const formName = managePlanFormNames.ADD_SPONSOR_MANAGE_PLAN;
  const fields = formFields[formName];
  const [formValues, setFormValues] = useState({});
  // const apiData = get(state, "api.data", {});

  const [showWarning, setShowWarning] = useState(false);
  const DeleteToastMessage = "You are attempting to delete sponsor.";
  const DeleteToastMessageHead = "Delete Sponsor?";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  // const { response: data, loading: load } = useRequest({
  //   method: getSponsor,
  //   payload: parseInt(sponsorId),
  //   defaultResponse: [],
  // });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  useDeepEffect(() => {
    if (parseInt(sponsorId) != 0) {
      setLoading(true);
      getSponsor(parseInt(sponsorId)).then((response) => {
        setData(response);
        setLoading(false);
      });
    }
  }, [sponsorId]);
  const sponsorsListData = get(data, "sponsor", {});
  const schema = Yup.object().shape();
  // const checkSSN = (val) => {
  //   var result = false;
  //   sponsorsListData.forEach((item, index) => {
  //     if (item.id !== sponsorId && item.ssn === val) result = true;
  //   });
  //   return result;
  // };

  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.SPONSOR,
        pathParam: [FLOW_TYPES.EDIT, planId],
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.SPONSOR,
        pathParam: [FLOW_TYPES.EDIT, planId],
      }),
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.ADD_SPONSOR,
            pathParam: [FLOW_TYPES.SAVE, planId, sponsorId],
          })
        ),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => {
        onDeleteClick();
      },
    },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTrashAlt,
    //   onClick: () => {
    //     onDeleteClick();
    //   },
    // },
  ];
  const handleClose = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (!isEmpty(sponsorsListData)) {
      setFormValues(
        (!isEmpty(sponsorsListData) && {
          ...sponsorsListData,
          firstName: sponsorsListData.name.firstName,
          lastName: sponsorsListData.name.lastName,
          email: sponsorsListData.contactDetails.email,
          mobilePhoneNumber: sponsorsListData.contactDetails.mobilePhoneNumber,
        }) ||
          {}
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sponsorsListData]);

  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    setLoading(true);
    const { history } = props;
    const name = {
      firstName: values.firstName || undefined,
      lastName: values.lastName || undefined,
      middleName: values.middleName || undefined,
    };

    const contactDetails = {
      mobilePhoneNumber: values.mobilePhoneNumber || undefined,
      workPhoneNumber: values.workPhoneNumber || undefined,
      email: values.email || undefined,
      website: values.website || undefined,
    };
    values.contactDetails = contactDetails;
    values.name = name;
    let objectKeys = Object.keys(values);
    let requestObject = {};
    objectKeys.forEach((key) => {
      if (values[key]) {
        requestObject[key] = values[key];
      }
    });
    saveSponsor({
      id: parseInt(sponsorId) ? parseInt(sponsorId) : 0,
      planId: parseInt(planId) ? parseInt(planId) : 0,
      ...requestObject,
    }).then((response) => {
      setLoading(false);
      if (response.isSuccessful) {
        const newPlanId = get(response, "planId");
        dispatch(
          setManagePlanFlow({
            planId: planId,
          })
        );
        dispatch(
          setchangeReviewFlag({
            module: "sponsor",
            review: response.isCompleted,
          })
        );
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.SPONSOR,
            pathParam: [flow, planId],
          })
        );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
      } else {
        setSubmitting(false);
        for (var i = 0; i < response.errorMessages.length; i++) {
          var _ = response.errorMessages[i];
          setFieldTouched(_.controlName, true);
          setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
        }
      }
      dispatch(
        setManagePageLevelData({
          formName: formName,
          fieldData: values,
        })
      );
    });
  };

  const onDeleteClick = () => {
    setShowWarning(true);
  };
  const handleCancelClick = () => {
    setShowWarning(false);
  };
  const handleConfirmClick = () => {
    setShowWarning(false);
    deleteSponsor(parseInt(sponsorId)).then((response) => {
      if (response.isSuccessful) {
        const newPlanId = get(response, "plan.id");
        dispatch(
          setManagePlanFlow({
            planId: planId,
          })
        );
        dispatch(
          setchangeReviewFlag({
            module: "sponsor",
            review: response.isCompleted,
          })
        );
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.SPONSOR,
            pathParam: [flow, planId],
          })
        );
        dispatch(
          setManagePlanToastInfo({
            showToast: true,
            toastMessage: "Data deleted successfully",
          })
        );
      }
    });
  };

  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  const layoutHeader = sponsorId && "Sponsor";
  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...formValues,
      }}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={schema}
      onSubmit={onFormSubmit}
      enableReinitialize
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        submitForm,
        errors,
        values,
        setSubmitting,
        ...rest
      }) => {
        return (
          <LoaderWrapper isLoading={loading}>
            <Form
              autoComplete="off"
              className="h-100"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <ManagePlanLayout
                buttons={buttons}
                pageFlow={newFlow || flow}
                layoutHeader={layoutHeader}
              >
                <Row>
                  <Col md="2">
                    <Field
                      isRequired
                      size="sm"
                      name={fields.firstName}
                      label={"First name"}
                      type="text"
                      autoComplete="off"
                      value={values[fields.firstName]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                    />
                  </Col>
                  <Col md="2">
                    <Field
                      isRequired
                      size="sm"
                      name={fields.lastName}
                      label={"Last name"}
                      type="text"
                      autoComplete="off"
                      value={values[fields.lastName]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="5">
                    <Field
                      name={fields.ssn}
                      label={"Social Security Number"}
                      type="text"
                      autoComplete="off"
                      value={getFormattedSsn(values[fields.ssn])}
                      //onChange={handleChange}
                      onChange={(e) => {
                        setFieldValue(
                          fields.ssn,
                          getFormattedSsn(e.target.value)
                        );
                      }}
                      disabled={isEdit && !isSave}
                      placeholder={FORM_PLACEHOLDERS.ssn}
                      noLabelTransform
                      component={FieldInputSSN}
                      maxLength="11"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <Field
                      isRequired
                      name={fields.email}
                      label={"Email"}
                      type="text"
                      autoComplete="off"
                      value={values[fields.email]}
                      onChange={handleChange}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <Field
                      name={fields.mobilePhoneNumber}
                      label={"Phone Number"}
                      type="text"
                      autoComplete="off"
                      //onChange={handleChange}
                      onChange={(e) => {
                        setFieldValue(
                          fields.mobilePhoneNumber,
                          getFormattedPhone(e.target.value)
                        );
                      }}
                      disabled={isEdit && !isSave}
                      component={FieldInput}
                      value={getFormattedPhone(
                        values[fields.mobilePhoneNumber]
                      )}
                      placeholder={FORM_PLACEHOLDERS.phone}
                      maxLength="12"
                    />
                  </Col>
                </Row>
                <DeleteWarning
                  DeleteToastMessageHead={DeleteToastMessageHead}
                  DeleteToastMessage={DeleteToastMessage}
                  showModal={showWarning}
                  handleConfirmClick={handleConfirmClick}
                  handleCancelClick={handleCancelClick}
                />
                <Modal show={isModalOpen} onHide={handleClose}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div className="text-right">
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="#000"
                        onClick={handleClose}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="pd-15">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          color="#f94f50"
                          size="3x"
                        />
                      </div>
                      <div className="remove-text">
                        <p>{errorMsg}</p>
                        <br />
                        <Button className="cancel-btn" onClick={handleClose}>
                          Ok
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </ManagePlanLayout>
            </Form>
          </LoaderWrapper>
        );
      }}
    </Formik>
  );
};

export default AddSponsorContainer;
